var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0576 13.8979C12.1747 13.5138 12.5319 13.2344 12.9544 13.2344H23.4544C23.8769 13.2344 24.2341 13.5138 24.3513 13.8979L18.2044 17.9958L12.0576 13.8979ZM10.8919 14.1616C10.8918 14.1676 10.8918 14.1736 10.8919 14.1796V21.6719C10.8919 22.811 11.8153 23.7344 12.9544 23.7344H23.4544C24.5935 23.7344 25.5169 22.811 25.5169 21.6719V14.1796M24.3919 15.2229V21.6719C24.3919 22.1896 23.9722 22.6094 23.4544 22.6094H12.9544C12.4366 22.6094 12.0169 22.1896 12.0169 21.6719V15.2229L17.8924 19.1399C18.0813 19.2659 18.3275 19.2659 18.5164 19.1399L24.3919 15.2229ZM25.5169 14.1616C25.5113 13.0272 24.5901 12.1094 23.4544 12.1094H12.9544C11.8188 12.1094 10.8975 13.0272 10.8919 14.1616",
    fill: "#282828"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b7a97b52982f9b175b762cceaf28991c.svg";
export { ForwardRef as ReactComponent };